import type { ReactNode } from "react";
import logo from "../../../spec/trame/logo.svg";
import { LanguageSwitch } from "../features/i18n/LanguageSwitch";
import { m } from "../paraglide/messages.js";

type AuthLayoutProps = {
  title: string;
  intro?: string;
  /** How things stand, above the title, on a screen that reports rather than asks. */
  state?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

/** The frame of every page a person passes through outside the app: the logo, one card that does one thing, and the
 * way on beneath it. */
export function AuthLayout({ title, intro, state, children, footer }: AuthLayoutProps) {
  return (
    <div className="flex min-h-dvh flex-col items-center bg-background px-4 py-8 sm:py-12">
      <header className="relative flex w-full max-w-md items-center justify-between gap-3 sm:justify-center">
        <img src={logo} alt={m.brand_name()} className="h-7 w-auto" />
        <div className="sm:absolute sm:right-0">
          <LanguageSwitch />
        </div>
      </header>
      <main className="mt-8 w-full max-w-md rounded-card border border-hairline bg-white p-6 shadow-card sm:p-7 [&_button[type=submit]]:w-full">
        {state === undefined ? null : <div className="mb-4">{state}</div>}
        <h1 className="text-[22px] leading-tight font-semibold tracking-[-0.02em] text-graphite">{title}</h1>
        {intro === undefined ? null : <p className="mt-2 text-sm text-text-muted">{intro}</p>}
        <div className="mt-5 flex flex-col gap-4">{children}</div>
      </main>
      {footer === undefined ? null : <footer className="mt-6 text-center text-sm text-text-muted">{footer}</footer>}
    </div>
  );
}
